export const containsNewPathSegment = (pathname: string) => {
  return pathname.includes('new');
};
